import {
    FETCH_PART_MASTER_REQUEST,
    FETCH_PART_MASTER_SUCCESS,
    FETCH_PART_MASTER_FAILURE,
    CREATE_PART_MASTER_FORM,
    UPDATE_PART_MASTER_FORM,
    CREATE_PART_MASTER_SUCCESS,
    FETCH_SINGLE_PART_MASTER_SUCCESS,
    UPDATE_PART_MASTER_SUCCESS,
    DELETE_PART_MASTER_SUCCESS,
    CREATE_PART_MASTER_REQUEST,
    UPDATE_PART_MASTER_REQUEST,
    FETCH_SINGLE_PART_MASTER_REQUEST,
    DELETE_PART_MASTER_REQUEST,
    RESET_PART_MASTER_INFO,
    CREATE_PART_MASTER_FAILURE,
    UPDATE_PART_MASTER_FAILURE,
    FETCH_SINGLE_PART_MASTER_FAILURE,
    DELETE_PART_MASTER_FAILURE,
    FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_REQUEST,
    FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_SUCCESS,
    FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_FAILURE,
    FETCH_PRINTING_TYPE_REQUEST,
    FETCH_PRINTING_TYPE_SUCCESS,
    FETCH_PRINTING_TYPE_FAILURE,
    FETCH_PARTY_MASTER_SUCCESS,
    FETCH_PARTY_MASTER_REQUEST,
    FETCH_PARTY_MASTER_FAILURE
} from './partMaster.actionsType';

export const PART_MASTER = 'partMaster';

let initialState = {
    loading: false,
    partMasterList: [],
    partMasterListByStyleId: [],
    partMasterForm: {
        fldFKPartName: [],
        fldIsTransactionRequired: false,
    },
    selectedState: {},
    errorMessage: '',
    printForm: [],
    deletePartId: ''
};

export let partMasterReducer = (state = initialState, action) => {
    let { type, updatePayload, payload } = action;

    switch (type) {
        case FETCH_PART_MASTER_REQUEST:
        case CREATE_PART_MASTER_REQUEST:
        case UPDATE_PART_MASTER_REQUEST:
        case FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_REQUEST:
        case FETCH_SINGLE_PART_MASTER_REQUEST:
        case DELETE_PART_MASTER_REQUEST:
        case FETCH_PRINTING_TYPE_REQUEST:
        case FETCH_PARTY_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PART_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partMasterList: updatePayload
            };
        case FETCH_PARTY_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partyMaster: updatePayload
            };
        case FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                partMasterListByStyleId: updatePayload
            };
        case CREATE_PART_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partMasterForm: {
                    fldFKPartName: []
                }
            };
        case UPDATE_PART_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partMasterForm: {
                    fldFKPartName: []
                }
            };
        case FETCH_SINGLE_PART_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                partMasterForm: updatePayload
            };
        case FETCH_PRINTING_TYPE_SUCCESS:
            return {
                ...state,
                loading: false,
                printForm: updatePayload
            }
        case DELETE_PART_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                deletePartId: updatePayload,
                partMasterForm: {
                    fldFKPartName: []
                }
            };
        case RESET_PART_MASTER_INFO:
            return {
                ...state,
                partMasterForm: {
                    fldFKPartName: [],
                    fldIsTransactionRequired: false,
                },
                deletePartId: ''

            };
        case CREATE_PART_MASTER_FORM:
        case UPDATE_PART_MASTER_FORM:
            return {
                ...state,
                loading: false,
                partMasterForm: {
                    ...state.partMasterForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PART_MASTER_BY_STYLE_DETAIL_ID_FAILURE:
            return {
                partMasterListByStyleId: [],
                ...state,
                loading: false
            };
        case FETCH_PART_MASTER_FAILURE:
        case CREATE_PART_MASTER_FAILURE:
        case UPDATE_PART_MASTER_FAILURE:
        case FETCH_SINGLE_PART_MASTER_FAILURE:
        case DELETE_PART_MASTER_FAILURE:
        case FETCH_PRINTING_TYPE_FAILURE:
        case FETCH_PARTY_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
